import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faArrowLeft,
    faArrowsAltH,
    faHistory,
    faInfoCircle, faLandmark, faPencilAlt,
    faPlus,
    faSignOutAlt,
    faTag
} from '@fortawesome/free-solid-svg-icons'
import {faEdit, faTrashAlt} from "@fortawesome/free-regular-svg-icons";
import {faGithub, faGoogle, faMicrosoft, faYahoo} from "@fortawesome/free-brands-svg-icons";

library.add(faPlus, faEdit, faTag, faInfoCircle, faArrowLeft, faArrowsAltH, faSignOutAlt, faHistory, faLandmark, faPencilAlt, faTrashAlt, faGoogle, faGithub, faMicrosoft, faYahoo);
